import { useState, useEffect } from 'react';
import NavBar from '../Common/NavBar/NavBar';
import SideBar from '../Common/SideBar/SideBar';
import Grid from '../Common/Grid/Grid';
import { Button, Modal, Form, Select, Input, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import {
  getAllAdhkar,
  addAdhkar,
  deactivateAdhkar,
  activateAdhkar,
  getAllCategoriesFOrAzkar,
  editAdhkar
} from '../../Network/Network';
import { baseUrl } from '../../Network/Services';

import { toastError, toastSuccess } from '../../Helpers/toasters';

function AdhkarScreen() {
  const [tableLoading, setTableLoading] = useState(true);
  const [dataSource, setDataSource] = useState([]);
  const [categories, setCategories] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingAdhkar, setEditingAdhkar] = useState(null);
  const [editImageUrl, setEditImageUrl] = useState(null);

  const [form] = Form.useForm();
  const [editForm] = Form.useForm();

  useEffect(() => {
    fetchAdhkar();
    fetchCategories();
  }, []);

  const fetchAdhkar = () => {
    setTableLoading(true);
    getAllAdhkar(
      (success) => {
        if (success?.isSuccess) {
          setDataSource(success.data);
        } else {
          toastError('فشل تحميل الأذكار');
        }
        setTableLoading(false);
      },
      () => {
        toastError('حدث خطأ أثناء تحميل الأذكار');
        setTableLoading(false);
      }
    );
  };

  const fetchCategories = () => {
    getAllCategoriesFOrAzkar(
      (success) => {
        if (success?.isSuccess) {
          setCategories(success.data);
        }
      },
      () => {
        toastError('تعذر تحميل التصنيفات');
      }
    );
  };

  const handleAddAdhkar = (values) => {
    console.log('values', values);
    const hasImage =
      values.image && Array.isArray(values.image) && values.image.length > 0;

    if (hasImage) {
      const formData = new FormData();
      formData.append('categoryId', values.categoryId);
      formData.append('title', values.title);
      formData.append('titleEn', values.titleEn);

      formData.append('azkar', JSON.stringify(values.azkarList));
      formData.append('image', values.image[0].originFileObj);

      addAdhkar(
        formData,
        (res) => {
          if (res?.isSuccess) {
            toastSuccess('تمت إضافة الأذكار بنجاح');
            setIsModalOpen(false);
            form.resetFields();
            fetchAdhkar();
          } else {
            toastError('فشل في إضافة الأذكار');
          }
        },
        () => {
          toastError('حدث خطأ أثناء إضافة الأذكار');
        }
      );
    } else {
      const payload = {
        categoryId: values.categoryId,
        title: values.title,
        titleEn: values.titleEn,

        azkar: JSON.stringify(values.azkarList)
      };

      addAdhkar(
        payload,
        (res) => {
          if (res?.isSuccess) {
            toastSuccess('تمت إضافة الأذكار بنجاح');
            setIsModalOpen(false);
            form.resetFields();
            fetchAdhkar();
          } else {
            toastError('فشل في إضافة الأذكار');
          }
        },
        () => {
          toastError('حدث خطأ أثناء إضافة الأذكار');
        }
      );
    }
  };
  // Upload change handler
  const handleEditImageChange = (info) => {
    if (info.fileList.length > 0) {
      const file = info.fileList[0].originFileObj;
      if (file) {
        setEditImageUrl(URL.createObjectURL(file)); // show new image preview
      }
    } else {
      setEditImageUrl(` ${baseUrl}${editingAdhkar?.image}` || null); // revert to old if cleared
    }
  };

  const handleEditAdhkar = (values) => {
    const hasImage =
      values.image && Array.isArray(values.image) && values.image.length > 0;

    if (hasImage) {
      const formData = new FormData();
      formData.append('zekrId', editingAdhkar._id);
      formData.append('categoryId', values.categoryId);
      formData.append('title', values.title);
      formData.append('titleEn', values.titleEn);

      formData.append('azkar', JSON.stringify(values.azkarList));
      formData.append('image', values.image[0].originFileObj);

      editAdhkar(
        formData,
        (res) => {
          if (res?.isSuccess) {
            toastSuccess('تم تعديل الأذكار بنجاح');
            setIsEditModalOpen(false);
            editForm.resetFields();
            setEditingAdhkar(null);
            fetchAdhkar();
          } else {
            toastError('فشل في تعديل الأذكار');
          }
        },
        () => {
          toastError('حدث خطأ أثناء تعديل الأذكار');
        }
      );
    } else {
      const payload = {
        zekrId: editingAdhkar._id,
        categoryId: values.categoryId,
        title: values.title,
        titleEn: values.titleEn,

        azkar: JSON.stringify(values.azkarList)
      };

      editAdhkar(
        payload,
        (res) => {
          if (res?.isSuccess) {
            toastSuccess('تم تعديل الأذكار بنجاح');
            setIsEditModalOpen(false);
            editForm.resetFields();
            setEditingAdhkar(null);
            fetchAdhkar();
          } else {
            toastError('فشل في تعديل الأذكار');
          }
        },
        () => {
          toastError('حدث خطأ أثناء تعديل الأذكار');
        }
      );
    }
  };

  const handleToggleStatus = (record) => {
    const apiCall = record.isActive ? deactivateAdhkar : activateAdhkar;
    apiCall(
      { zekrId: record._id },
      (res) => {
        if (res?.isSuccess) {
          toastSuccess('تم تحديث الحالة بنجاح');
          fetchAdhkar();
        } else {
          toastError('فشل في تحديث الحالة');
        }
      },
      () => toastError('حدث خطأ أثناء تحديث الحالة')
    );
  };

  const columns = [
    {
      title: 'العنوان',
      dataIndex: 'title',
      key: 'title'
    },
    {
      title: ' العنوان بالانجليزيه',
      dataIndex: 'titleEn',
      key: 'titleEn'
    },
    {
      title: 'التصنيف',
      dataIndex: ['categoryId', 'name'],
      key: 'category'
    },
    {
      title: 'الأذكار',
      key: 'azkar',
      render: (_, record) => {
        const azkarList = Array.isArray(record.azkar) ? record.azkar : [];
        return azkarList.map((azkar, index) => (
          <div key={index} style={{ marginBottom: 8 }}>
            <b>({azkar.number})</b> {azkar.zekrAr} / {azkar.zekrEn}
          </div>
        ));
      }
    },
    {
      title: 'الحالة',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive) => (isActive ? 'مفعل' : 'معطل')
    },
    {
      title: 'إجراء',
      key: 'action',
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => handleToggleStatus(record)}>
            {record.isActive ? 'تعطيل' : 'تفعيل'}
          </Button>
          <Button
            type="link"
            onClick={() => {
              setEditingAdhkar(record);
              setEditImageUrl(`${baseUrl}${record.image}`); // Assuming 'image' is the field with the image URL
              console.log('editImageUrl', editImageUrl);
              setIsEditModalOpen(true);

              const azkarList = Array.isArray(record.azkar) ? record.azkar : [];

              editForm.setFieldsValue({
                categoryId: record.categoryId._id,
                title: record.title,
                azkarList: azkarList.length
                  ? azkarList
                  : [{ zekrEn: '', zekrAr: '', number: 1 }],
                image: []
              });
            }}
          >
            تعديل
          </Button>
        </>
      )
    }
  ];

  const filteredData = dataSource.filter((item) =>
    item.categoryId?.name.toLowerCase().includes(searchValue.toLowerCase())
  );

  return (
    <div className="d-flex">
      <SideBar parent={'adhkar'} />
      <div className="flex-1 section">
        <NavBar
          getSearchedValue={(value) => {
            setSearchValue(value);
          }}
        />

        <h2 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: 10 }}>
          الأذكار
        </h2>

        <Button
          type="primary"
          onClick={() => {
            setIsModalOpen(true);
            form.setFieldsValue({
              categoryId: undefined,
              title: '',
              azkarList: [{ zekrEn: '', zekrAr: '', number: 1 }],
              image: []
            });
          }}
          style={{ marginBottom: 20 }}
        >
          + إضافة أذكار جديدة
        </Button>

        <Grid
          columns={columns}
          dataSource={filteredData}
          loading={tableLoading}
          rowKey={'_id'}
          options={true}
          exportMe={false}
          emptyTableText={{
            emptyText: 'لا توجد أذكار'
          }}
        />

        {/* Add Modal */}
        <Modal
          title={
            <div style={{ textAlign: 'left', fontWeight: 'bold' }}>إضافة أذكار جديدة</div>
          }
          visible={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          footer={null}
          destroyOnClose
          width={700}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={handleAddAdhkar}
            style={{ direction: 'rtl', textAlign: 'right' }}
          >
            <Form.Item
              name={'title'}
              label="العنوان"
              rules={[{ required: true, message: 'يرجى ادخال العنوان' }]}
            >
              <Input placeholder="ادخل العنوان" />
            </Form.Item>
            <Form.Item
              name={'titleEn'}
              label=" العنوان بالانجليزيه"
              rules={[{ required: true, message: ' يرجى ادخال العنوان بالانجليزيه' }]}
            >
              <Input placeholder="ادخل العنوان بالانجليزيه" />
            </Form.Item>

            <Form.Item
              name="categoryId"
              label="التصنيف"
              rules={[{ required: true, message: 'يرجى اختيار التصنيف' }]}
            >
              <Select placeholder="اختر التصنيف">
                {categories.map((cat) => (
                  <Select.Option key={cat._id} value={cat._id}>
                    {cat.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="Current Image">
              {editImageUrl && (
                <img
                  src={editImageUrl}
                  alt="Adhkar"
                  style={{ width: 100, height: 'auto', borderRadius: 4, marginBottom: 8 }}
                />
              )}
            </Form.Item>
            <Form.Item
              name="image"
              label="الصورة (اختياري)"
              valuePropName="fileList"
              getValueFromEvent={(e) => (Array.isArray(e) ? e : e && e.fileList)}
            >
              <Upload
                beforeUpload={() => false}
                maxCount={1}
                onChange={handleEditImageChange}
              >
                <Button icon={<UploadOutlined />}>اختر صورة (اختياري)</Button>
              </Upload>
            </Form.Item>

            <Form.List
              name="azkarList"
              initialValue={[{ zekrEn: '', zekrAr: '', number: 1 }]}
            >
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <div
                      key={key}
                      style={{
                        marginBottom: 16,
                        paddingBottom: 12,
                        borderBottom: '1px dashed #ccc'
                      }}
                    >
                      <Form.Item
                        {...restField}
                        name={[name, 'zekrAr']}
                        label="الذكر بالعربي"
                        rules={[{ required: true, message: 'يرجى إدخال الذكر بالعربي' }]}
                      >
                        <Input placeholder="أدخل الذكر بالعربي" />
                      </Form.Item>

                      <Form.Item
                        {...restField}
                        name={[name, 'zekrEn']}
                        label="الذكر بالإنجليزي"
                        rules={[
                          { required: true, message: 'يرجى إدخال الذكر بالإنجليزي' }
                        ]}
                      >
                        <Input placeholder="Enter Zekr in English" />
                      </Form.Item>

                      <Form.Item
                        {...restField}
                        name={[name, 'number']}
                        label="العدد"
                        rules={[{ required: true, message: 'يرجى إدخال العدد' }]}
                      >
                        <Input type="number" min={1} />
                      </Form.Item>

                      <Button danger onClick={() => remove(name)}>
                        إزالة هذا الذكر
                      </Button>
                    </div>
                  ))}

                  <Form.Item>
                    <Button type="dashed" onClick={() => add()} block>
                      + إضافة ذكر جديد
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>

            <Button type="primary" htmlType="submit" block>
              إضافة
            </Button>
          </Form>
        </Modal>

        {/* Edit Modal */}
        <Modal
          title={
            <div style={{ textAlign: 'left', fontWeight: 'bold' }}>تعديل الأذكار</div>
          }
          visible={isEditModalOpen}
          onCancel={() => {
            setIsEditModalOpen(false);
            setEditingAdhkar(null);
          }}
          footer={null}
          destroyOnClose
          width={700}
        >
          <Form
            form={editForm}
            layout="vertical"
            onFinish={handleEditAdhkar}
            style={{ direction: 'rtl', textAlign: 'right' }}
          >
            <Form.Item
              name={'title'}
              label="العنوان"
              rules={[{ required: true, message: 'يرجى ادخال العنوان' }]}
            >
              <Input placeholder="ادخل العنوان" />
            </Form.Item>
            <Form.Item
              name={'titleEn'}
              label=" العنوان بالانجليزيه"
              rules={[{ required: true, message: ' يرجى ادخال العنوان بالانجليزيه' }]}
            >
              <Input placeholder="ادخل العنوان بالانجليزيه" />
            </Form.Item>

            <Form.Item
              name="categoryId"
              label="التصنيف"
              rules={[{ required: true, message: 'يرجى اختيار التصنيف' }]}
            >
              <Select placeholder="اختر التصنيف">
                {categories.map((cat) => (
                  <Select.Option key={cat._id} value={cat._id}>
                    {cat.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="Current Image">
              {editImageUrl && (
                <img
                  src={editImageUrl}
                  alt="Adhkar"
                  style={{ width: 100, height: 'auto', borderRadius: 4, marginBottom: 8 }}
                />
              )}
            </Form.Item>
            <Form.Item
              name="image"
              label="الصورة (اختياري)"
              valuePropName="fileList"

              getValueFromEvent={(e) => (Array.isArray(e) ? e : e && e.fileList)}
            >
              <Upload
                beforeUpload={() => false}
                maxCount={1}
                onChange={handleEditImageChange}
              >
                <Button icon={<UploadOutlined />}>اختر صورة جديدة (اختياري)</Button>
              </Upload>
            </Form.Item>

            <Form.List name="azkarList">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <div
                      key={key}
                      style={{
                        marginBottom: 16,
                        paddingBottom: 12,
                        borderBottom: '1px dashed #ccc'
                      }}
                    >
                      <Form.Item
                        {...restField}
                        name={[name, 'zekrAr']}
                        label="الذكر بالعربي"
                        rules={[{ required: true, message: 'يرجى إدخال الذكر بالعربي' }]}
                      >
                        <Input placeholder="أدخل الذكر بالعربي" />
                      </Form.Item>

                      <Form.Item
                        {...restField}
                        name={[name, 'zekrEn']}
                        label="الذكر بالإنجليزي"
                        rules={[
                          { required: true, message: 'يرجى إدخال الذكر بالإنجليزي' }
                        ]}
                      >
                        <Input placeholder="Enter Zekr in English" />
                      </Form.Item>

                      <Form.Item
                        {...restField}
                        name={[name, 'number']}
                        label="العدد"
                        rules={[{ required: true, message: 'يرجى إدخال العدد' }]}
                      >
                        <Input type="number" min={1} />
                      </Form.Item>

                      <Button danger onClick={() => remove(name)}>
                        إزالة هذا الذكر
                      </Button>
                    </div>
                  ))}

                  <Form.Item>
                    <Button type="dashed" onClick={() => add()} block>
                      + إضافة ذكر جديد
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>

            <Button type="primary" htmlType="submit" block>
              حفظ التعديلات
            </Button>
          </Form>
        </Modal>
      </div>
    </div>
  );
}

export default AdhkarScreen;
